/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import DeleteAction from './DeleteAction/index'
import EditAction from './EditAction/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/BlockedTime/BlockedTimeDialog/Actions/Content"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<EditAction
  viewPath={`${viewPath}/EditAction`}
/>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
</div>
{children}
</React.Fragment>)
}